"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantMembersContract = void 0;
const contract_1 = require("../base/contract");
const members_schemas_1 = require("../../schemas/merchant/members.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.MerchantMembersContract = (0, contract_1.createContract)({
    name: "MerchantMembers",
    baseUrl: "/merchants",
    version: "1",
    serviceModule: "merchant",
    endpoints: {
        listMembers: {
            method: "GET",
            path: "/:merchantId/members",
            body: null,
            query: members_schemas_1.listMembersQuerySchema,
            params: members_schemas_1.listMembersParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.listMembersResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:staff"],
            documentation: {
                summary: "List merchant members",
                description: "Retrieves paginated list of members with filtering by role and search.",
                tags: ["Merchant", "Members"],
                deprecated: false,
            },
            tests: [
                "should return paginated members",
                "should filter by role",
                "should search by name or phone",
                "should mask phone numbers",
            ],
        },
        getMember: {
            method: "GET",
            path: "/:merchantId/members/:userId",
            body: null,
            query: null,
            params: members_schemas_1.getMemberParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.getMemberResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:staff"],
            documentation: {
                summary: "Get member details",
                description: "Retrieves member details including analytics for modal view.",
                tags: ["Merchant", "Members"],
                deprecated: false,
            },
            tests: [
                "should return member details with analytics",
                "should include total spending and redemptions",
                "should return 404 for non-member user",
            ],
        },
        updateMemberCredits: {
            method: "PATCH",
            path: "/:merchantId/members/:userId/credits",
            body: members_schemas_1.updateMemberCreditsBodySchema,
            query: null,
            params: members_schemas_1.updateMemberCreditsParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.updateMemberCreditsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Adjust member credits",
                description: "Manually adjust member credit balance with reason (FR67). Positive adds, negative subtracts.",
                tags: ["Merchant", "Members", "Credits"],
                deprecated: false,
            },
            tests: [
                "should add credits with positive amount",
                "should subtract credits with negative amount",
                "should require reason for adjustment",
                "should prevent balance going negative",
                "should create audit log entry",
            ],
        },
        getPersonalMemberCard: {
            method: "GET",
            path: "/:merchantId/members/:userId/personal-card",
            body: null,
            query: null,
            params: members_schemas_1.getPersonalMemberCardParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.getPersonalMemberCardResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Get a member personal card",
                description: "Retrieves the personal member card assigned to an active restaurant member.",
                tags: ["Merchant", "Members", "Cards"],
                deprecated: false,
            },
            tests: [
                "should return the personal card or an empty card value",
                "should reject inactive or cross-merchant members",
            ],
        },
        createPersonalMemberCard: {
            method: "POST",
            path: "/:merchantId/members/:userId/personal-card",
            body: members_schemas_1.createPersonalMemberCardBodySchema,
            query: null,
            params: members_schemas_1.createPersonalMemberCardParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createPersonalMemberCardResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Assign a personal member card",
                description: "Assigns one restaurant-scoped personal member ID to an existing member.",
                tags: ["Merchant", "Members", "Cards"],
                deprecated: false,
            },
            tests: [
                "should assign a personal card after persistence commits",
                "should be idempotent for an identical assignment",
                "should reject duplicate IDs and owner races",
            ],
        },
        updatePersonalMemberCard: {
            method: "POST",
            path: "/:merchantId/members/:userId/personal-card/edit",
            body: members_schemas_1.updatePersonalMemberCardBodySchema,
            query: null,
            params: members_schemas_1.updatePersonalMemberCardParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.updatePersonalMemberCardResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Correct a personal member card",
                description: "Corrects a personal member ID using an expected revision.",
                tags: ["Merchant", "Members", "Cards"],
                deprecated: false,
            },
            tests: [
                "should increment revision for an explicit correction",
                "should reject stale revisions and duplicate IDs",
            ],
        },
        getCardBalances: {
            method: "GET",
            path: "/:merchantId/member-cards/:cardId/balances",
            body: null,
            query: null,
            params: members_schemas_1.getCardBalancesParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.getCardBalancesResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Get card balances",
                description: "Returns the latest prepaid and bonus values received for one restaurant card.",
                tags: ["Merchant", "Members", "Balances"],
                deprecated: false,
            },
            tests: ["should return latest values per type", "should reject another restaurant's card"],
        },
        createCardBalances: {
            method: "POST",
            path: "/:merchantId/member-cards/:cardId/balances",
            body: members_schemas_1.createCardBalancesBodySchema,
            query: null,
            params: members_schemas_1.createCardBalancesParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createCardBalancesResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Save card balances",
                description: "Appends one receipt per supplied balance in one transaction; a retried operation returns its original outcome.",
                tags: ["Merchant", "Members", "Balances"],
                deprecated: false,
            },
            tests: [
                "should append one receipt per supplied value",
                "should replay a repeated operation without new receipts",
                "should conflict on a changed repeated operation",
            ],
        },
        createCardBackground: {
            method: "POST",
            path: "/:merchantId/member-cards/:cardId/background",
            body: members_schemas_1.createCardBackgroundBodySchema,
            query: null,
            params: members_schemas_1.createCardBackgroundParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createCardBackgroundResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Set card background",
                description: "Validates and stores one card background image and records it on the card with an expected revision.",
                tags: ["Merchant", "Members", "Cards"],
                deprecated: false,
            },
            tests: ["should store a valid image and bump the revision", "should reject invalid files and stale revisions"],
        },
        removeCardBackground: {
            method: "POST",
            path: "/:merchantId/member-cards/:cardId/background/remove",
            body: members_schemas_1.removeCardBackgroundBodySchema,
            query: null,
            params: members_schemas_1.removeCardBackgroundParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.removeCardBackgroundResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Remove card background",
                description: "Clears the card background with an expected revision.",
                tags: ["Merchant", "Members", "Cards"],
                deprecated: false,
            },
            tests: ["should clear the background and bump the revision"],
        },
        listMerchantGroups: {
            method: "GET",
            path: "/:merchantId/member-groups",
            body: null,
            query: null,
            params: members_schemas_1.listMerchantGroupsParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.listMerchantGroupsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "List merchant member groups",
                description: "Lists company/group cards owned by the selected restaurant.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: [
                "should list only groups for the selected restaurant",
                "should include group name, member ID, revision, and member count",
            ],
        },
        getMerchantGroup: {
            method: "GET",
            path: "/:merchantId/member-groups/:cardId",
            body: null,
            query: null,
            params: members_schemas_1.getMerchantGroupParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.getMerchantGroupResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Get merchant member group",
                description: "Retrieves a group card and its assigned restaurant members.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should return assigned-member details", "should reject a personal card target"],
        },
        createMerchantGroup: {
            method: "POST",
            path: "/:merchantId/member-groups",
            body: members_schemas_1.createMerchantGroupBodySchema,
            query: null,
            params: members_schemas_1.createMerchantGroupParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createMerchantGroupResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Create merchant member group",
                description: "Creates one restaurant-owned shared group card.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should create one group card", "should reject duplicate member IDs"],
        },
        updateMerchantGroup: {
            method: "POST",
            path: "/:merchantId/member-groups/:cardId/edit",
            body: members_schemas_1.updateMerchantGroupBodySchema,
            query: null,
            params: members_schemas_1.updateMerchantGroupParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.updateMerchantGroupResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Correct merchant member group",
                description: "Corrects a group name or member ID with an expected revision.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should increment the group revision", "should reject stale revisions"],
        },
        createMerchantGroupMemberAssignment: {
            method: "POST",
            path: "/:merchantId/member-groups/:cardId/members",
            body: members_schemas_1.createMerchantGroupMemberAssignmentBodySchema,
            query: null,
            params: members_schemas_1.createMerchantGroupMemberAssignmentParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createMerchantGroupMemberAssignmentResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Assign a merchant member to a group",
                description: "Links an active same-restaurant member to an existing group card.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should assign an existing member", "should make repeated assignment idempotent"],
        },
        removeMerchantGroupMember: {
            method: "DELETE",
            path: "/:merchantId/member-groups/:cardId/members/:userId/remove",
            body: null,
            query: null,
            params: members_schemas_1.removeMerchantGroupMemberParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.removeMerchantGroupMemberResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Remove a merchant member from a group",
                description: "Removes only the selected group/member link.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should remove only the selected link", "should be idempotent when repeated"],
        },
        listMemberGroupCards: {
            method: "GET",
            path: "/:merchantId/members/:userId/group-cards",
            body: null,
            query: null,
            params: members_schemas_1.listMemberGroupCardsParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.listMemberGroupCardsResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "List member group cards",
                description: "Lists the group cards assigned to one active restaurant member.",
                tags: ["Merchant", "Members", "Groups"],
                deprecated: false,
            },
            tests: ["should list all assigned groups", "should preserve a personal card separately"],
        },
        createMemberEnrollment: {
            method: "POST",
            path: "/:merchantId/members/enrollment",
            body: members_schemas_1.createMemberEnrollmentBodySchema,
            query: null,
            params: members_schemas_1.createMemberEnrollmentParamsSchema,
            headers: null,
            response: {
                success: members_schemas_1.createMemberEnrollmentResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    forbidden: api_schemas_1.baseErrorResponseSchema,
                    notFound: api_schemas_1.baseErrorResponseSchema,
                    conflict: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                    internalServerError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ["auth:required", "merchant:admin"],
            documentation: {
                summary: "Enroll a member with a personal card",
                description: "Creates or reuses a customer identity and saves its restaurant membership and personal card.",
                tags: ["Merchant", "Members", "Enrollment"],
                deprecated: false,
            },
            tests: [
                "should complete new member enrollment after application persistence commits",
                "should recover the same identity after an interrupted Auth response",
                "should replay or conflict by operation key without duplicates",
            ],
        },
        // REMOVED: inviteMember endpoint - feature removed from codebase
        // Members now join via self-registration using merchant registration link
        // ============================================
        // V2 ENDPOINTS (uncomment when ready)
        // ============================================
        /*
            removeMember: {
                method: 'DELETE',
                path: '/:merchantId/members/:userId',
                body: null,
                query: null,
                params: removeMemberParamsSchema,
                headers: null,
                response: {
                    success: removeMemberResponseSchema,
                    errors: {
                        unauthorized: baseErrorResponseSchema,
                        forbidden: baseErrorResponseSchema,
                        notFound: baseErrorResponseSchema,
                    },
                },
                middleware: ['auth:required', 'merchant:admin'],
                documentation: {
                    summary: 'Remove member from merchant',
                    description: 'Soft-deletes a member by setting is_active to false. Admin cannot remove themselves.',
                    tags: ['Merchant', 'Members'],
                    deprecated: false,
                },
                tests: [
                    'should soft delete member',
                    'should prevent self-removal',
                    'should return 404 for non-member',
                    'should require admin role',
                ],
            },
            */
    },
});
